import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id", "disabled", "data-bs-target"]
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 1,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.noButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          id: `${_ctx.uniqueId}Button`,
          class: _normalizeClass(["btn", `${_ctx.currentButtonStyle} ${_ctx.buttonClass}`]),
          disabled: _ctx.buttonDisabled,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
          "data-bs-target": `#${_ctx.uniqueId}`
        }, [
          _renderSlot(_ctx.$slots, "button", { modalData: _ctx.modalData }, undefined, true)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", _ctx.show || _ctx.open ? 'show' : '']),
      id: _ctx.uniqueId,
      tabindex: "-1",
      "aria-labelledby": `${_ctx.uniqueId}Label`,
      "aria-hidden": "true",
      style: _normalizeStyle(_ctx.modalStyle)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog", _ctx.size]),
        style: _normalizeStyle(_ctx.modalDialogStyle)
      }, [
        _createElementVNode("div", {
          class: "modal-content",
          style: _normalizeStyle(_ctx.modalContentStyle)
        }, [
          (_ctx.title || _ctx.$slots.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", {
                  class: "modal-title fs-5",
                  id: `${_ctx.uniqueId}Label`
                }, _toDisplayString(_ctx.title), 9, _hoisted_4),
                _createElementVNode("h1", {
                  class: "modal-title fs-5",
                  id: `${_ctx.uniqueId}Label`
                }, [
                  _renderSlot(_ctx.$slots, "title", { modalData: _ctx.modalData }, undefined, true)
                ], 8, _hoisted_5),
                (_ctx.show_close_btn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn-close",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
                      "aria-label": "Close"
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "modal-body",
            style: _normalizeStyle(_ctx.modalBodyStyle)
          }, [
            (_ctx.show_close_btn ?? !_ctx.title ?? !_ctx.$slots.title)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
                  "aria-label": "Close"
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "body", { modalData: _ctx.modalData }, undefined, true)
          ], 4),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer", {
                  modalData: _ctx.modalData,
                  dismissModal: _ctx.dismiss
                }, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ], 6)
    ], 14, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["modal-backdrop fade", _ctx.show || _ctx.open ? 'show' : '']),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
    }, null, 2)
  ], 64))
}